<div class="modal-body scroll-panel w-100-p h-adjust-px">
    <form [formGroup]="fmCompanyUser" autocomplete="off" class="scroll-panel h-100-p">
        <br>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group2">
                    <mat-form-field appearance="outline" class="d-block border-color-blue"
                        [ngClass]="(fmDet.txtName?.value && !fmDet.txtName?.invalid)?'has-value':''">
                        <mat-label>{{ 'companies.lblCompanyName' | translate }}</mat-label>
                        <input matInput maxlength="80" [formControl]="fmDet.txtName" [errorStateMatcher]="matcher"
                            (keypress)="onKeyPress($event)" data-type="notdoublespace" (keyup)="modelChanged($event)"
                            data-valid="all">
                        <mat-error *ngIf="fmDet.txtName.hasError('required')">
                            {{ 'common.lblErrorRequired' | translate}}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtName.hasError('minlength')">
                            {{ 'companies.txtNameMinlength' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group2">
                    <mat-form-field appearance="outline" class="d-block"
                        [ngClass]="(fmDet.txtRFC?.value && !fmDet.txtRFC?.invalid)?'has-value':''">
                        <mat-label>{{ 'companies.lblRFC' | translate }}</mat-label>
                        <input matInput maxlength="13" [formControl]="fmDet.txtRFC" [errorStateMatcher]="matcher">
                        <mat-error *ngIf="fmDet.txtRFC.hasError('required')">
                            {{ 'common.lblErrorRequired' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtRFC.hasError('pattern')">
                            {{ 'common.lblErrorFormating' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtRFC.hasError('minlength')">
                            {{ 'companies.txtRFCMinlength' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group2">
                    <mat-form-field appearance="outline" class="d-block"
                        [ngClass]="(fmDet.txtContactName?.value && !fmDet.txtContactName?.invalid)?'has-value':''">
                        <mat-label>{{ 'companies.lblContactName' | translate }} </mat-label>
                        <input matInput maxlength="50" [formControl]="fmDet.txtContactName"
                            [errorStateMatcher]="matcher" autocomplete="off" (keypress)="onKeyPress($event)"
                            data-type="notdoublespace" (keyup)="modelChanged($event)" data-valid="notnumber">
                        <mat-error *ngIf="fmDet.txtContactName.hasError('required')">
                            {{ 'common.lblErrorRequired' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtContactName.hasError('minlength')">
                            {{ 'companies.txtContactNameMinlength' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group2"><mat-form-field appearance="outline" class="d-block"
                        [ngClass]="(fmDet.txtContactEmail?.value && !fmDet.txtContactEmail?.invalid)?'has-value':''">
                        <mat-label>
                            {{ 'companies.lblContactEmail' | translate }}
                        </mat-label>
                        <input matInput maxlength="40" [formControl]="fmDet.txtContactEmail"
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="fmDet.txtContactEmail.hasError('required')">
                            {{ 'common.lblErrorRequired' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtContactEmail.hasError('pattern')">
                            {{'companies.txtContactEmailPattern' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtContactEmail.hasError('minlength')">
                            {{ 'companies.txtContactEmailMinlength' | translate }}
                        </mat-error>
                    </mat-form-field></div>
            </div>
        </div>

        <hr>

        <!-- Admin User-->
        <div class="flex justify-content-space-between">
            <span class="fw-bold title-modal-detail fz-14-px">
                {{ 'companies.lblUserAdmin' | translate }}
            </span>
        </div>
        <hr class="line-h-blue-purple-dialogs">
        <br>
        <div class="row">

            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group2"><mat-form-field appearance="outline" class="d-block"
                        [ngClass]="(fmDet.txtNameUser?.value && !fmDet.txtNameUser?.invalid)?'has-value':''">
                        <mat-label>
                            {{ 'companies.lblFullName' | translate }}
                        </mat-label>
                        <input matInput maxlength="50" [formControl]="fmDet.txtNameUser" minlength="5"
                            [errorStateMatcher]="matcher">
                        <mat-error *ngIf="fmDet.txtNameUser.hasError('required')">
                            {{'common.lblErrorRequired' | translate }}</mat-error>
                        <mat-error *ngIf="fmDet.txtNameUser.hasError('minlength')">
                            {{ 'companies.lblFullNameMinlength' | translate }}
                        </mat-error>
                    </mat-form-field></div>

            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group2"><mat-form-field appearance="outline" class="d-block"
                        [ngClass]="(fmDet.txtUserName?.value && !fmDet.txtUserName?.invalid)?'has-value':''">
                        <mat-label>
                            {{ 'companies.lblUserName' | translate }}
                        </mat-label>
                        <input matInput maxlength="30" minlength="5" [formControl]="fmDet.txtUserName"
                            autocomplete="off" [errorStateMatcher]="matcher">
                        <mat-error *ngIf="fmDet.txtUserName.hasError('required')">
                            {{ 'common.lblErrorRequired' | translate }}</mat-error>
                        <mat-error *ngIf="fmDet.txtUserName.hasError('minlength')">
                            {{ 'companies.lblUserNameMinlength' | translate }}
                        </mat-error>
                    </mat-form-field></div>

            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group2"><mat-form-field appearance="outline" class="d-block"
                        [ngClass]="(fmDet.txtPhone?.value && !fmDet.txtPhone?.invalid)?'has-value':''">
                        <mat-label>
                            {{ 'companies.lblPhoneNumber' | translate }}
                        </mat-label>
                        <input matInput maxlength="10" [formControl]="fmDet.txtPhone" [errorStateMatcher]="matcher">
                        <mat-error *ngIf="fmDet.txtPhone.hasError('required')">
                            {{ 'common.lblErrorRequired' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtPhone.hasError('minlength')">
                            {{ 'companies.lblPhoneNumberMinlength' | translate }}
                        </mat-error>
                    </mat-form-field></div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group2"><mat-form-field appearance="outline" class="d-block"
                        [ngClass]="(fmDet.txtEmail?.value && !fmDet.txtEmail?.invalid)?'has-value':''">
                        <mat-label>
                            {{ 'companies.lblAdminEmail' | translate }}
                        </mat-label>
                        <input matInput maxlength="40" [formControl]="fmDet.txtEmail" [errorStateMatcher]="matcher">
                        <mat-error *ngIf="fmDet.txtEmail.hasError('required')">
                            {{'common.lblErrorRequired' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtEmail.hasError('pattern')">
                            {{ 'common.lblErrorFormating' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtEmail.hasError('minlength')">
                            {{ 'companies.txtAdminEmailPattern' | translate }}
                        </mat-error>
                    </mat-form-field></div>

            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="input-group">
                    <mat-form-field appearance="outline" class="help-block"
                        [ngClass]="(fmDet.txtPassword?.value && !fmDet.txtPassword?.invalid)?'has-value':''">
                        <mat-label>
                            {{ 'companies.lblNewPassword' | translate }}
                        </mat-label>
                        <input matInput [type]="show ? 'text' : 'password'" #currentPwd minlength="8" maxlength="12"
                            [formControl]="fmDet.txtPassword" [errorStateMatcher]="matcher">
                        <mat-error *ngIf="fmDet.txtPassword.hasError('required')">
                            {{ 'common.lblErrorRequired' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtPassword.hasError('pattern')">
                            {{ 'companies.txtPasswordPattern' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <div *ngIf="show" class="input-group-append-01">
                        <span class="input-group-text-01" style="cursor: pointer;" data-toggle="tooltip"
                            data-placement="top" title="{{ 'companies.lblHidePassword' | translate }}"
                            (click)="changeInput()">
                            <i class="fa fa-eye-slash"></i>
                        </span>
                    </div>
                    <div *ngIf="!show" class="input-group-append-01">
                        <span class="input-group-text-01" style="cursor: pointer;" data-toggle="tooltip"
                            data-placement="top" title="{{ 'companies.lblShowPassword' | translate }}"
                            (click)="changeInput()">
                            <i class="fa fa-eye"></i>
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="input-group">
                    <mat-form-field appearance="outline" class="d-block"
                        [ngClass]="(fmDet.txtPassword2?.value && !fmDet.txtPassword2?.invalid)?'has-value':''">
                        <mat-label>
                            {{ 'companies.lblNewPassword2' | translate }}
                        </mat-label>
                        <input [type]="showConfirmPassword ? 'text' : 'password'" autocomplete="new-password" matInput
                            minlength="8" maxlength="12" [formControl]="fmDet.txtPassword2" required>
                        <mat-error *ngIf="fmDet.txtPassword2.hasError('required')">
                            {{'common.lblErrorRequired' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtPassword2.value !== fmDet.txtPassword.value">
                            {{ 'companies.lblPasswordsDoNotMatch' | translate }}
                        </mat-error>
                        <mat-error *ngIf="fmDet.txtPassword2.hasError('pattern')">
                            {{ 'companies.txtPasswordPattern' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <div *ngIf="showConfirmPassword" class="input-group-append-01">
                        <span class="input-group-text-01" style="cursor: pointer;" data-toggle="tooltip"
                            data-placement="top" title="{{ 'companies.lblHidePassword' | translate }}"
                            (click)="changeInputConfirmPassword()">
                            <i class="fa fa-eye-slash"></i>
                        </span>
                    </div>
                    <div *ngIf="!showConfirmPassword" class="input-group-append-01">
                        <span class="input-group-text-01" style="cursor: pointer;" data-toggle="tooltip"
                            data-placement="top" title="{{ 'companies.lblShowPassword' | translate }}"
                            (click)="changeInputConfirmPassword()">
                            <i class="fa fa-eye"></i>
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                <mat-form-field appearance="fill"
                    [ngClass]="(fmDet.ddlRol?.value && !fmDet.ddlRol?.invalid)?'has-value':''">
                    <mat-label>{{ 'companies.lblRol' | translate }}</mat-label>
                    <mat-select formControlName="ddlRol">
                        <mat-option value="1">{{ 'companies.lblAdmin' | translate }}</mat-option>
                        <mat-option value="2">User</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

        </div>

        <br><br>

    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary " data-dismiss="modal" (click)="onClose(0)">
        {{ 'common.btnCancel' | translate }}
    </button>
    <button [disabled]="this.fmCompanyUser.invalid" (click)="onSaveCompanyAdminInfo(mdlAddTypePersonLightIdentity)"
        class="btn btn-info " type="submit">
        {{ 'common.btnNext' | translate }}
    </button>
</div>

<!-- Modal type person and light identity -->
<ng-template #mdlAddTypePersonLightIdentity>
    <div class="container-fluid p-2">
        <div class="modal-header modal-header-custom">
            <div class="flex justify-content-space-between">
                <span class="fw-bold title-modal-detail fz-14-px">
                    <!-- {{ 'companies.lblTypePerson' | translate }} -->
                    {{ 'companies.lblIdentity' | translate }}
                </span>
            </div>
            <hr class="line-h-blue-purple-dialogs">
        </div>
        <div class="hr-detail"></div>
        <div class="modal-body">
            <!-- IS OK FOR TYPE PERSONS --- IOMC
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group">
                        <div class="alert alert-gray" role="alert">
                            <span class="lbl-form">
                                {{ 'companies.lblTypePersonInstructions' | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </div> -->

            <form [formGroup]="fmTypePerson">
                <div class="col-lg-12">
                    <div class="form-group">
                        <!-- IS OK FOR TYPE PERSONS --- IOMC
                        <div class="row mt-2">
                            <input type="checkbox" id="physical" formControlName="chckbxFPerson" [value]="true" class="checkbox-blue-disabled" [checked]="true">
                            &nbsp;<span class="fw-w-bold">{{ 'companies.lblNaturalPerson' | translate }}</span>&nbsp;{{ 'companies.lblNaturalPersonSection' | translate }}
                        </div>
                        <div class="row mt-2">
                            <input type="checkbox" id="moral" formControlName="chckbxMPerson" [value]="false" class="checkbox-blue" [checked]="false">
                            &nbsp;<span class="fw-w-bold">{{ 'companies.lblMoralPerson' | translate }}</span>&nbsp;{{ 'companies.lblMoralPersonSection' | translate }}
                        </div> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <!-- IS OK FOR TYPE PERSONS --- IOMC
                            <hr> -->
                            <ng-container *ngIf="isEnabled">
                                <mat-slide-toggle [ngClass]="'status-obj'" formControlName="mstLightIdentity"
                                    [checked]="true" (toggleChange)="isEnabled = false"></mat-slide-toggle>
                                &nbsp;
                                <label for="mstLightIdentity">{{ 'companies.lblLightIdentityQuestion' |
                                    translate}}</label>
                            </ng-container>
                            <ng-container *ngIf="!isEnabled">
                                <mat-slide-toggle [ngClass]="'status-obj'" formControlName="mstLightIdentity"
                                    [checked]="false" (toggleChange)="isEnabled = true"></mat-slide-toggle>
                                &nbsp;
                                <label for="mstLightIdentity">{{ 'companies.lblLightIdentityQuestion' |
                                    translate}}</label>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </form>

        </div>

        <br><br><br>

        <div class="modal-footer">
            <div class="row w-100-p justify-content-space-between">
                <div class="col-lg-8 col-md-8 col-sm-12">
                    <button class="btn btn-back " data-dismiss="modal"
                        (click)="onCloseModalReference('mdlAddServices')">
                        {{'common.btnBack' | translate }}
                    </button>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="btn-group">
                        <button class="btn btn-secondary mr-3" data-dismiss="modal" (click)="onClose(0)">
                            {{'common.btnCancel' | translate }}
                        </button>
                        <button (click)="typePersonLightIdentity(mdlAddAsistenciaEvidencia)" class="btn btn-info"
                            type="submit">
                            {{'common.btnNext' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</ng-template>

<!-- Modal Sections -->
<ng-template #mdlAddSection>
    <form [formGroup]="fmSections" autocomplete="off">
        <div class="container-fluid p-2">
            <div class="modal-header modal-header-custom">
                <div class="flex justify-content-space-between">
                    <span class="fw-bold title-modal-detail fz-14-px">
                        {{ 'companies.lblEnrollmentsSections' | translate }}
                    </span>
                </div>
                <hr class="line-h-blue-purple-dialogs">
            </div>
            <div class="hr-detail"></div>
            <div class="modal-body body-modal-md">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-group">
                            <div class="alert alert-gray" role="alert">
                                <span class="lbl-form fz-12-px">
                                    {{'companies.lblEnrollmentsInstructions' | translate }}
                                </span><span class="lbl-required">*</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="col-lg-12 mb-3">
                            <i class="fa-brands fa-android text-blue-main mr-2"></i>
                            <span class="fz-12-px">
                                {{'companies.lblEnrollmentsAndroid' | translate | uppercase }}
                            </span>
                        </div>
                        <div class="col-lg-12">
                            <div class="content fz-12-px">
                                <div *ngFor="let item of this.sectionCat_movil_android">
                                    <mat-checkbox (change)="onChangeCheckSection($event, item)"
                                        checked="{{item.checked}}" disabled="{{item.disabled}}">
                                        <span class="item-cb-name ml-2">{{item.name}}:</span>
                                        <span class="item-cb-description ml-2">{{item.description}}</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="col-lg-12 mb-3">
                            <i class="fa-brands fa-apple text-blue-main mr-2"></i>
                            <span class="fz-12-px">
                                {{'companies.lblEnrollmentsiOS' | translate | uppercase }}
                            </span>
                        </div>
                        <div class="col-lg-12">
                            <div class="content fz-12-px">
                                <div *ngFor="let item of this.sectionCat_movil_iOS">
                                    <mat-checkbox (change)="onChangeCheckSection($event, item)"
                                        checked="{{item.checked}}" disabled="{{item.disabled}}">
                                        <span class="item-cb-name ml-2">{{item.name}}:</span>
                                        <span class="item-cb-description ml-2">{{item.description}}</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="col-lg-12 mb-3">
                            <i class="fa-solid fa-globe text-blue-main mr-2"></i>
                            <span class="fz-12-px">
                                {{'companies.lblEnrollmentsWebResponsive' | translate | uppercase }}
                            </span>
                        </div>
                        <div class="col-lg-12">
                            <div class="content fz-12-px">
                                <div *ngFor="let item of this.sectionCat_web_responsive">
                                    <mat-checkbox (change)="onChangeCheckSection($event, item)"
                                        checked="{{item.checked}}" disabled="{{item.disabled}}">
                                        <span class="item-cb-name ml-2">{{item.name}}:</span>
                                        <span class="item-cb-description ml-2">{{item.description}}</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="col-lg-12 mb-3">
                            <i class="fa-solid fa-earth-americas text-blue-main mr-2"></i>
                            <span class="fz-12-px">
                                {{'companies.lblEnrollmentsWeb' | translate | uppercase }}
                            </span>
                        </div>
                        <div class="col-lg-12">
                            <div class="content fz-12-px">
                                <div *ngFor="let item of this.sectionCat_web">
                                    <mat-checkbox (change)="onChangeCheckSection($event, item)"
                                        checked="{{item.checked}}" disabled="{{item.disabled}}">
                                        <span class="item-cb-name ml-2">{{item.name}}:</span>
                                        <span class="item-cb-description ml-2">{{item.description}}</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-lg-6 col-md-4 col-sm-12">
                        <div class="col-lg-12 pt-2">
                            <span class="py-2 font-weight-bold fz-12-px">
                                {{'companies.lblOtherDocuments' | translate | uppercase }}
                            </span>
                        </div>
                        <div class="col-lg-12 pt-3">
                            <mat-form-field appearance="outline"
                                [ngClass]="(fmSectionsG.ddlDocuments?.value && !fmSectionsG.ddlDocuments?.invalid)?'has-value':''">
                                <mat-label>{{ 'companies.ddlDocuments' | translate }}</mat-label>
                                <mat-select [formControl]="fmSectionsG.ddlDocuments">
                                    <mat-option *ngFor="let item of this.catDocuments"
                                        value="{{item.value}}">{{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <br><br><br><br><br>

            </div>

            <div class="modal-footer">
                <div class="row w-100-p justify-content-space-between">
                    <div class="col-lg-8 col-md-8 col-sm-12">
                        <button class="btn btn-back " data-dismiss="modal"
                            (click)="onCloseModalReference('mdlAddAsistenciaEvidencia');">
                            {{'common.btnBack' | translate }}
                        </button>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                        <div class="btn-group">
                            <button class="btn btn-secondary mr-3" data-dismiss="modal" (click)="onClose(0)">
                                {{'common.btnCancel' | translate }}
                            </button>
                            <button (click)="validatingBioSections(mdlAddServices)" class="btn btn-info" type="submit">
                                {{'common.btnNext' | translate }}
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </form>
</ng-template>


<!-- Modal Services -->
<ng-template #mdlAddServices>
    <div class="container-fluid p-2">
        <div class="modal-header modal-header-custom">
            <div class="flex justify-content-space-between">
                <span class="fw-bold title-modal-detail fz-14-px">
                    {{ 'companies.lblServices' | translate }}
                </span>
            </div>
            <hr class="line-h-blue-purple-dialogs">
        </div>
        <div class="hr-detail"></div>
        <div class="modal-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group">
                        <div class="alert alert-gray" role="alert">
                            <span class="lbl-form">
                                {{ 'companies.lblServicesInstructions' | translate }}
                            </span><span class="lbl-required">*</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="scroll-panel">
                        <div *ngFor="let item of this.servicesCat">
                            <mat-checkbox (change)="onChangeCheckService($event, item)" checked="{{item.checked}}"
                                [disabled]="!item.enabled" class="ml-3">
                                <span class="item-cb-name ml-2">{{item.name}}:</span>
                                <span class="item-cb-description ml-2">{{item.description}}</span>
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 pt-3" *ngIf="this.showDivUrlINE">

                    <hr>

                    <form [formGroup]="fmServices" autocomplete="off">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group2">
                                <mat-form-field appearance="outline" class="d-block"
                                    [ngClass]="(fmServicesG.txtUrlINE?.value && !fmServicesG.txtUrlINE?.invalid)?'has-value':''">
                                    <mat-label>
                                        {{ 'companies.lblUrlIneService' | translate }}
                                    </mat-label>
                                    <input matInput maxlength="80" [formControl]="fmServicesG.txtUrlINE">
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>

        <br><br><br>

        <div class="modal-footer">
            <div class="row w-100-p justify-content-space-between">
                <div class="col-lg-8 col-md-8 col-sm-12">
                    <button class="btn btn-back " data-dismiss="modal" (click)="onCloseModalReference('mdlAddSection')">
                        {{'common.btnBack' | translate }}
                    </button>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="btn-group">
                        <button class="btn btn-secondary mr-3" data-dismiss="modal" (click)="onClose(0)">
                            {{'common.btnCancel' | translate }}
                        </button>
                        <button (click)="onSaveServices(mdlAddProviders)" class="btn btn-info" type="submit">
                            {{'common.btnNext' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</ng-template>


<!-- Modal providers -->
<ng-template #mdlAddProviders>
    <div class="container-fluid p-2">
        <div class="modal-header modal-header-custom">
            <div class="flex justify-content-space-between">
                <span class="fw-bold title-modal-detail fz-14-px">
                    {{ 'companies.lblProviders' | translate }}
                </span>
            </div>
            <hr class="line-h-blue-purple-dialogs">
        </div>
        <div class="hr-detail"></div>
        <div class="modal-body">
            <div class="row">
                <div class="col-lg-12">

                    <ng-container *ngFor="let section of catProvidersSections">

                        <div class="form-group">
                            <div class="alert alert-gray" role="alert">
                                <span class="lbl-form">
                                    {{ "companies.providers."+section.name | translate }}
                                </span>
                            </div>
                        </div>
                        <br>

                        <ng-container *ngFor="let provider of listProviders">

                            <ng-container *ngIf="section.id === provider.type">

                                <div class="radio-group">
                                    <input type="radio" name="clasificacionActual{{provider.type}}"
                                        id="provider{{provider.providerId}}"
                                        (click)="selectProvider(provider.providerId, provider.type)"
                                        [disabled]="provider.disabledFront"> &nbsp;{{ provider.description }}
                                </div>

                                <br>

                            </ng-container>

                        </ng-container>

                    </ng-container>

                </div>
            </div>

        </div>

        <br><br><br>

        <div class="modal-footer">
            <div class="row w-100-p justify-content-space-between">
                <div class="col-lg-8 col-md-8 col-sm-12">
                    <button class="btn btn-back " data-dismiss="modal"
                        (click)="onCloseModalReference('mdlAddProviders')">
                        {{'common.btnBack' | translate }}
                    </button>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="btn-group">
                        <button class="btn btn-secondary mr-3" data-dismiss="modal" (click)="onClose(0)">
                            {{'common.btnCancel' | translate }}
                        </button>
                        <button (click)="onSaveProvidersAndAll()" class="btn btn-info" type="submit">
                            {{'common.btnSave' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</ng-template>


<!-- Modal Config module of asistence and evidence -->
<ng-template #mdlAddAsistenciaEvidencia>
    <div class="container-fluid p-2">
        <div class="modal-header modal-header-custom">
            <div class="flex justify-content-space-between">
                <span class="fw-bold title-modal-detail fz-14-px">
                    {{ 'companies.lblAssistance' | translate }}
                </span>
                <p class="fz-11-px">* {{ 'common.lblsAreRequired' | translate }}</p>
            </div>
            <hr class="line-h-blue-purple-dialogs">
        </div>

        <div class="hr-detail"></div>
        <div class="modal-body">
            <div class="row mb-3">
                <div class="col-md-12">
                    <mat-slide-toggle [ngClass]="'status-obj'" [(ngModel)]="activateAsistance" class="mr-2"
                        [checked]="activateAsistance"></mat-slide-toggle>
                    <label>{{ 'companies.lblAssistanceQuestion' | translate}}</label>
                </div>
            </div>

            <ng-container *ngIf="activateAsistance">
                <form [formGroup]="fmAssistance" autocomplete="off" class="scroll-panel my-2-p">

                    <ng-container *ngFor="let questionSection of questionSections; let indexQS = index">

                        <ng-container *ngIf="indexQS !== 0">
                            <hr>
                        </ng-container>
                        <div class="flex justify-content-space-between">
                            <span class="fw-bold title-modal-detail fz-14-px">
                                {{ ('companies.assistance.'+questionSection) | translate }}
                            </span>
                        </div>
                        <hr class="line-h-blue-purple-dialogs">

                        <ng-container *ngFor="let question of questionsCat">

                            <ng-container *ngIf="(question.parent - 1) === indexQS">
                                <mat-checkbox (change)="onChangeCheckQuestion($event, question)"
                                    checked="{{question.checked}}" disabled="{{!question.enabled}}">
                                    <span class="item-cb-description ml-2">{{question.question}}</span>
                                </mat-checkbox>
                                <ng-container *ngIf="question.templateRef">
                                    <ng-container
                                        *ngTemplateOutlet='question.templateRef; context { $implicit: question }'>
                                    </ng-container>
                                </ng-container>
                                <br>
                            </ng-container>

                        </ng-container>

                    </ng-container>

                </form>
            </ng-container>


        </div>

        <br><br><br>

        <div class="modal-footer">
            <div class="row w-100-p justify-content-space-between">
                <div class="col-lg-8 col-md-8 col-sm-12">
                    <button class="btn btn-back " data-dismiss="modal"
                        (click)="onCloseModalReference('mdlAddTypePersonLightIdentity')">
                        {{'common.btnBack' | translate }}
                    </button>
                </div>

                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="btn-group">
                        <button class="btn btn-secondary mr-3" data-dismiss="modal" (click)="onClose(0)">
                            {{'common.btnCancel' | translate }}
                        </button>
                        <button [disabled]="(fmAssistance.invalid && activateAsistance && !isValidCaeProvider)"
                            (click)="assistanceEvidence(mdlAddSection)" class="btn btn-info" type="button">
                            {{'common.btnNext' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</ng-template>

<!-- Form to get data of BioStar -->
<ng-template #formNotifsMail>
    <ng-container *ngIf="isCehckbxIsNotifsMail">
        <br><br>
        <div class="row">

            <ng-container *ngFor="let mail of listEmailToNotifs; let indexMail = index; trackBy: setValueMailNotifs">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <mat-form-field appearance="outline" class="search-field "
                        [ngClass]="(!mail.isRegex && mail.mail !== '') ? 'errorInput' : '' ">
                        <mat-label>
                            {{ 'companies.lblAdminEmail' | translate }}
                        </mat-label>
                        <ng-container *ngIf="indexMail !== 0">
                            <button class="btn-serch-field"
                                (click)="deleteMailNotifs(indexMail)"><mat-icon>delete_outline</mat-icon></button>
                        </ng-container>
                        <input type="email" id="{{indexMail}}" matInput maxlength="255" autocomplete="off"
                            value="{{mail.mail}}" (change)="setValueMailNotifs(indexMail, $event)"
                            (paste)="setValueMailNotifs(indexMail, $event)" />
                    </mat-form-field>
                </div>
            </ng-container>

            <div class="col-lg-6 col-md-6 col-sm-12">
                <button [disabled]="(listEmailToNotifs[listEmailToNotifs.length-1].mail === '')"
                    (click)="addMailNotifs()" class="btn btn-info w-100-p mt-2" type="button">
                    {{'companies.assistance.addMail' | translate }}
                </button>
            </div>

        </div>
    </ng-container>
</ng-template>

<!-- Form to get data of BioStar -->
<ng-template #formBio>
    <ng-container *ngIf="isCehckbxIsBioStar">
        <br><br>
        <form [formGroup]="fmAssistance" autocomplete="off">
            <div class="row">

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group2">
                        <mat-form-field appearance="outline" class="d-block">
                            <mat-label>
                                {{ 'companies.assistance.lblBioStarUser' | translate }}
                            </mat-label>
                            <input matInput maxlength="255" type="text" id="txtBioUser" formControlName="txtBioUser"
                                autocomplete="off">
                            <mat-error *ngIf="fmAssistanceG.txtBioUser.hasError('required')">
                                {{'common.lblErrorRequired' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="input-group">
                        <mat-form-field appearance="outline" class="help-block">
                            <mat-label> {{ 'companies.assistance.lblBioStarPassword' | translate }}</mat-label>
                            <input matInput id="txtBioPassword" formControlName="txtBioPassword"
                                [type]="showBioStar ? 'text' : 'password'"
                                [autocomplete]="showBioStar ? 'off' : 'new-password'">
                            <mat-error *ngIf="fmAssistanceG.txtBioPassword.hasError('required')">
                                {{ 'common.lblErrorRequired' | translate }}
                            </mat-error>
                        </mat-form-field>
                        <div *ngIf="showBioStar" class="input-group-append-01">
                            <span class="input-group-text-01" style="cursor: pointer;" data-toggle="tooltip"
                                data-placement="top" title="{{ 'companies.lblHidePassword' | translate }}"
                                (click)="changeBioStar()">
                                <i class="fa fa-eye-slash"></i>
                            </span>
                        </div>
                        <div *ngIf="!showBioStar" class="input-group-append-01">
                            <span class="input-group-text-01" style="cursor: pointer;" data-toggle="tooltip"
                                data-placement="top" title="{{ 'companies.lblShowPassword' | translate }}"
                                (click)="changeBioStar()">
                                <i class="fa fa-eye"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group2">
                        <mat-form-field appearance="outline" class="d-block border-color-blue">
                            <mat-label>{{ 'companies.assistance.lblBioStarServer' | translate }}</mat-label>
                            <input matInput type="text" id="txtBioServert" formControlName="txtBioServert"
                                maxlength="255">
                            <mat-error *ngIf="fmAssistanceG.txtBioServert.hasError('required')">
                                {{ 'common.lblErrorRequired' | translate}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group2">
                        <mat-form-field appearance="outline" class="d-block border-color-blue">
                            <mat-label>{{ 'companies.assistance.lblBioStarPort' | translate }}</mat-label>
                            <input matInput type="text" id="txtBioPort" formControlName="txtBioPort" maxlength="5">
                            <mat-error *ngIf="fmAssistanceG.txtBioPort.hasError('required')">
                                {{ 'common.lblErrorRequired' | translate}}
                            </mat-error>
                            <mat-error *ngIf="fmAssistanceG.txtBioPort.hasError('minlength')">
                                {{ 'companies.txtPortMinlength' | translate }}
                            </mat-error>
                            <mat-error *ngIf="fmAssistanceG.txtBioPort.hasError('pattern')">
                                {{ 'companies.txtOnlyNums' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

            </div>
        </form>
    </ng-container>
</ng-template>


<!-- Form to get data -->
<ng-template #formFace let-question>
    <ng-container *ngIf="isCbxFaceComparation">
        <div class="row">
            <ng-container *ngFor="let provider of providersCAECat; let indexQS = index">
                <div class="col-lg-12 col-md-12 col-sm-12 ">
                    <ng-container *ngIf="(question.parent - 1) === provider.type">
                        <div class="radio-group radio-group-custom d-block ml-3 mb-1">
                            <input type="radio" name="clasificacionActual{{provider.type}}"
                                id="provider{{provider.providerId}}" checked="{{provider.checked}}"
                                (click)="selectProviderCAE(provider.providerId, provider.type)">
                            &nbsp;{{ provider.description }}
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<!-- Form to get data -->
<ng-template #formLiveness let-question>
    <ng-container *ngIf="isCbxLiveness">
        <div class="row">
            <ng-container *ngFor="let provider of providersCAECat; let indexQS = index">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <ng-container *ngIf="(question.parent) === provider.type">
                        <div class="radio-group radio-group-custom d-block ml-3 mb-1">
                            <input type="radio" name="clasificacionActual{{provider.type}}"
                                id="provider{{provider.providerId}}" checked="{{provider.checked}}"
                                (click)="selectProviderCAE(provider.providerId, provider.type)">
                            &nbsp;{{ provider.description }}
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-container *ngIf="isConfirmationDialog">
    <app-confirmation-dialog [confirmationDialog]="confirmationDialog"
        (onConfirmDialog)="orchestratorCloseDialog($event)"></app-confirmation-dialog>
</ng-container>